var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.getStripeSession}},[_c('stripe-checkout',{ref:"checkoutRef",attrs:{"pk":"pk_test_51JrgmmIU6fXqzdC5Wd17sVt2xxCfOHbfySPOmjskjPdOmiii3Die920tNmIwEXGnyeJ5CUuLJ4GlIZ4DFGWfcpPa00Bc6wHwrJ","session-id":this.sessionID}}),_vm._v("docket! "+_vm._s(_vm.name)+" $"+_vm._s(_vm.amount)+" "+_vm._s(_vm.sessionID)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }